
import { gql } from '@apollo/client';

export const VALIDATE_VOUCHER = gql`
  mutation ValidateVoucher(
    $voucherCode: String!
    $journeyType: String!
    $deviceType: String
  ) {
    validateVoucher(
      input: {
        VoucherCode: $voucherCode
        productType: $journeyType
        deviceType: $deviceType
      }
    ) {
      RequestStatus
      Description
      VoucherStatus
      ProductType
      DeviceType
      OfferId
      OfferDescription
      ExpiryDate
      Campaigns
      ServiceCodes
      url
    }
  }
`;
